import { render, staticRenderFns } from "./TaskManagementIndex.vue?vue&type=template&id=a822d978&scoped=true"
import script from "./TaskManagementIndex.vue?vue&type=script&lang=js"
export * from "./TaskManagementIndex.vue?vue&type=script&lang=js"
import style0 from "./TaskManagementIndex.vue?vue&type=style&index=0&id=a822d978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a822d978",
  null
  
)

export default component.exports